import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/scan";
import {Html5Qrcode} from "html5-qrcode";
import {ListOrdersNotification, ViewOrderNotification} from "./wrb";
import {Html5QrcodeScanType} from "html5-qrcode/esm/core";
import jQuery from "jquery";

const server = Server.instance();

export class ScanView extends View {

    static classname = "scan-view";

    private scanInitted = false;
    private cameraId : string | undefined;

    private html5QrCode : Html5Qrcode | undefined;

    constructor() {
        super(ScanView.classname);
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
        };

        const out = this.pug(template, data);

        setTimeout(() => { this.checkStop(); }, 500);

        this.afterUpdate(() => {

            if (! this.scanInitted) {
                this.scanInitted = true;
                // triggers permission request
                Html5Qrcode.getCameras().then(devices => {
                    if (devices && devices.length) {
                        this.cameraId = devices[0].id;
                        this.update();
                    }
                }).catch(err => {
                    console.log("Err", err);
                });
            }
            if (this.cameraId) {
                const id = this.getUuid() + "-scan";

                const target = this.elt().find("#" + id);

                if (target.length == 0) {
                    return; // Not in DOM for some reason
                }

                const qrbox = (viewfinderWidth: number, viewfinderHeight: number) => {
                    return {
                        width: viewfinderWidth * 0.7,
                        height: viewfinderHeight * 0.7,
                    }
                }

                const config = {
                    "fps": 10,
                    "qrbox": qrbox,
                    "rememberLastUsedCamera": true,
                    "supportedScanTypes": [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
                };

                const html5QrCode = this.html5QrCode = new Html5Qrcode(id);
                html5QrCode.start(
                    { facingMode: "environment" },
                    {
                        fps: 10,
                        qrbox: qrbox
                    },
                    (decodedText, decodedResult) => {

                        this.onScan(decodedText);


                    },
                    (errorMessage) => {
                        console.log("html5QrCode", errorMessage)
                    })
                    .catch((err) => {
                        console.log("Failed", err);
                    });

            }

        });

        return out;
    }

    async onScan(qrcode: string) {

        const orders = await server.getOrdersByQRCode(qrcode);

        if (orders.length == 1)     {
            this.html5QrCode && this.html5QrCode.stop();
            this.notify(new ViewOrderNotification(orders[0].id as string));
        }

        if (orders.length > 1) {
            this.html5QrCode && this.html5QrCode.stop();
            const ids = orders.map(order => order.id as string);
            this.notify(new ListOrdersNotification(ids));
        }

    }

    checkStop() {
        if (this.html5QrCode) {
            if (this.elt().length == 0) {
                const h = this.html5QrCode;
                this.html5QrCode = undefined;
                h.stop();
            } else {
                setTimeout(() => { this.checkStop(); }, 500);
            }
        }
    }
}

View.on(
    "." + ScanView.classname,
    "click",
    ".login",
    function(that: ScanView, event, elt) {
        event.preventDefault();
    });

